import type {
  PublishingSite,
  StudioExperience,
} from '@studio/core/utils/experience';
import type { EnvironmentType } from '@studio/utils/environment';

import type { Role } from './roles';
import type { Evaluator } from './RuleEngine';

type StringRole = `${Role}`;

export interface AccessContext {
  readonly env: EnvironmentType;
  readonly app: string;
  readonly realm: string;
  readonly roles: ReadonlySet<StringRole>;
  readonly publishingSite: PublishingSite;
  readonly stackName: string;
  /** @deprecated */
  readonly subdivisionMarket: string;
  /** @deprecated */
  readonly subdivisionTenant: string;
  readonly studioExperience: StudioExperience;
}

export type AccessFn = Evaluator<AccessContext>;

function checkAccess(this: AccessContext, fn: AccessFn): boolean {
  return fn(this);
}

export function and(...fns: readonly AccessFn[]): AccessFn {
  return ctx => fns.every(checkAccess, ctx);
}

export function or(...fns: readonly AccessFn[]): AccessFn {
  return ctx => fns.some(checkAccess, ctx);
}

export function not(fn: AccessFn): AccessFn {
  return ctx => !fn(ctx);
}
